var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEtHdark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 4V9.91332L16.996 12.1466L11.998 4Z",
    fill: "#04111D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9987 4L7 12.1466L11.9987 9.91332V4Z",
    fill: "#04111D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 15.979V19.997L16.9994 13.0776L11.998 15.979Z",
    fill: "#04111D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9987 19.997V15.9783L7 13.0776L11.9987 19.997Z",
    fill: "#04111D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 15.0488L16.996 12.1468L11.998 9.91479V15.0488Z",
    fill: "#04111D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.1468L11.9987 15.0488V9.91479L7 12.1468Z",
    fill: "#04111D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtHdark);
export default __webpack_public_path__ + "static/media/ETHdark.0fd818061498aa9fb412013df83f156d.svg";
export { ForwardRef as ReactComponent };